import { useContext } from "react";
import RegistrationContext from "../contexts/RegistrationContext";
import Spinner from "../components/Spinner/Spinner";
import RegistrationType from "../pages/RegistrationType/RegistrationType";
import PersonalData from "../pages/PersonalData";
import Payment from "../pages/Payment/Payment";
import WorkshopSelection from "../pages/WorkshopSelection/WorkshopSelection";
import Conditions from "../pages/Conditions/Conditions";
import Options from "../pages/Options/Options";
import Membership from "../pages/Membership";
import PaperSelection from "../pages/PaperSelection";
import ConfirmationPage from "../pages/Confirmation/Confirmation";

const RegularUser = () => {
  const { screen, loading } = useContext(RegistrationContext);

  return (
    <>
      {/* <SidePanel isOpen={cartOpen} openCloseHandler={setCartOpen}>
        <Cart />
      </SidePanel>

      <SidePanel isOpen={userInfoOpen} openCloseHandler={setUserInfoOpen}>
        <UserInfo />
      </SidePanel>

      <SidePanel isOpen={paperOpen} openCloseHandler={setPaperOpen}>
        <SearchPapers />
      </SidePanel> */}


  
          {loading ? (
            <div className="flex justify-center h-full items-center">
              <Spinner />
            </div>
          ) : (
            <>
              {screen === "Registration Type" && <RegistrationType />}
              {screen === "Conditions" && <Conditions />}
              {screen === "Workshop Selection" && <WorkshopSelection />}
              {screen === "Additional Items" && <Options />}
              {screen === "Paper Selection" && <PaperSelection />}
              {screen === "Personal Data" && <PersonalData />}
              {screen === "Membership" && <Membership />}
              {screen === "Payment" && <Payment />}
              {screen === "Confirmation" &&  <ConfirmationPage />}
            </>
          )}

    </>
  );
};

export default RegularUser;
